import React from "react";
import '../App.css';
import { Link } from 'react-router-dom'

const About = () => {

    return (
        <div className="App-header">
            <Link style={{ color: 'white' }} to="/">Home</Link>



            <div
                style={{
                    fontFamily: "Arial, sans-serif",
                    padding: "32px",
                    maxWidth: "800px",
                    margin: "0 auto",
                    lineHeight: "1.6",
                }}
            >
                <h2>📘 About ZippyQ</h2>
                <p>
                    ZippyQ is a web-based pickup line queue dashboard for schools, daycares,
                    and church childcare programs.
                    <br /><br />
                    It replaces walkie-talkies, paper lists, clipboards, and spreadsheets
                    with a live, ID-only queue displayed on a TV or tablet &mdash;
                    making dismissal faster, safer, and more organized.
                </p>

                <h2>🚗 How it works</h2>
                <p>
                    Staff enter a <strong>Student ID</strong> from a smartphone or tablet when a vehicle arrives.
                    That ID instantly appears in the live pickup queue, which is displayed on a TV, tablet, or wall-mounted screen for easy visibility.
                    <br /><br />
                    No radios. No shouting. No confusion.
                </p>

                <h2>🔒 Privacy by Design</h2>
                <p>
                    ZippyQ is intentionally built to <strong>minimize student data</strong>:
                </p>
                <ul>
                    <li>No student names</li>
                    <li>No personal information</li>
                    <li>Student IDs only</li>
                </ul>
                <p>
                    This keeps the system simple, safe, and easy for organizations to approve.
                </p>



                {/*<h1>📘 About ZippyQ</h1>
                <p>
                    Welcome to <strong>ZippyQ</strong>, our <strong>School Queue Dashboard</strong> — a streamlined solution designed to simplify and modernize the carpool pickup process.
                </p>

                <p>
                    Built with clarity, speed, and real-world usability in mind, this app allows entry of Student ID to instantly join the pickup queue.
                    The queue is displayed live on a TV or tablet in a clean format, making it easy for staff to monitor lane activity at a glance.
                </p> */}

                <h2>🎯 Why use ZippyQ</h2>
                <p>No more clipboard confusion or walkie-talkie chaos. This solution brings structure and transparency to the pickup process.</p>
                <ul>
                    <li>Faster, more organized dismissal</li>
                    <li>Clear visibility across multiple pickup points</li>
                    <li>Reduced traffic congestion</li>
                    <li>A calmer, more professional pickup experience</li>
                    <li>Easily adapts to handle 1–15+ pickup positions with dynamic font scaling</li>
                </ul>

                {/*<h2>💡 Why It Matters</h2>
                <ul>
                    <li>Speed up dismissal</li>
                    <li>Reduce traffic congestion</li>
                    <li>Improve safety and accountability</li>
                    <li>Provide a professional, tech-forward experience</li>
                </ul>

                <h2>🛠️ Designed for Schools</h2>
                <p>
                    Whether you're managing a single-lane pickup or a multi-lane carpool system, this app scales to fit your needs.
                    It’s built with modern modular components, responsive layouts, and a backend that supports secure validation and future extensibility.
                </p> */}

                <h2>🧪 30-Day Free Pilot</h2>
                <p>
                    ZippyQ includes a full-featured free trial period so you can experience the power and simplicity of our Queue Dashboard with zero commitment.
                    During this trial, you'll have access to every feature — from live queue display to dynamic pickup point scaling.
                    Your team can use it during real pickup operations to see firsthand how it streamlines carpool pickup.
                    We're confident you'll find the experience smooth, professional, and tailored to your needs.
                </p>


                <h2>🚀 Sign Up Today</h2>
                <p>
                    Ready to streamline your school's carpool process? Start your free trial and experience the full power of our dashboard. It's fast to set up, easy to use, and built for real-world school environments.
                </p>


                <h2>📝 Instructions</h2>
                <h3>Getting Started</h3>
                <p>
                    Initial login requires association with an Organization account. If you’re an administrator, you’ll create your Organization during your first login. Administrators can manage user accounts and add user emails to associate them with the Organization. When a user signs up with an email already linked to an Organization, they will be automatically connected to that Organization. If the email used during sign‑up is not associated with any Organization, the user will be prompted to create a new Organization or contact their Organization administrator to request access.
                </p>
                <p>
                    Subscriptions are managed at the Organization level, not the user level. Organization administrators are responsible for setting up and maintaining the Organization’s subscription.
                </p>
                <p>
                    <Link to="/login" style={{ fontWeight: "bold", color: "#007bff", textDecoration: "underline" }}>
                        Click here to sign up or log in
                    </Link>
                    &nbsp;and take your pickup process to the next level.
                </p>

                <h3>Using ZippyQ</h3>
                {/*
                <p>
                    ZippyQ is designed to guide staff through the entire pickup process with just a few taps.
                    After signing in, the Home page presents buttons for each part of the system.
                    <strong> Arrived</strong> opens the entry screen used by intake staff to type a student’s numeric ID and submit it, replacing the traditional walkie‑talkie callout.
                    This screen supports rapid, repeated entry so multiple students can be checked in quickly.
                    <strong> Queue</strong> opens the live Dashboard, which displays all currently queued student IDs.
                </p>

                <h2>📝 How to Use ZippyQ</h2>
                */}

                <p>
                    ZippyQ is designed to streamline the student pickup process by replacing
                    walkie‑talkies with a fast, organized digital queue. After signing in, the
                    Home page displays all available sections of the app. Each section supports a
                    different part of the pickup workflow.
                </p>

                <h3>Arrived – Check-In Process</h3>
                <p>
                    Tap <strong>Arrived</strong> to open the entry screen used by staff stationed
                    at the intake point. Instead of calling out student numbers over a radio,
                    staff simply type the student’s numeric ID and press <strong>Submit</strong>.
                    The screen is optimized for rapid, repeated entry so multiple students can be
                    checked in quickly during busy times. Each submitted ID is immediately added
                    to the live queue.
                </p>

                <h3>Queue – Viewing the Active Pickup Queue</h3>
                <p>
                    Tap <strong>Queue</strong> to open the Dashboard. This view shows all
                    currently checked‑in student IDs in real time. This view is typically displayed
                    on a tablet or TV in the loading zone so staff can easily see which
                    students are up next. As new IDs are entered from the Arrived screen, the
                    Dashboard updates automatically, allowing multiple students to be picked up
                    simultaneously across your pickup points.
                </p>
                <p>
                    This page includes a numeric entry box that allows you to specify how
                    many pickup points you use. Adjusting this number instantly updates
                    the Dashboard layout so each cycle displays the correct number of students for
                    your pickup configuration.
                </p>
                <p>
                    The Queue view includes actions for maintaining the
                    Dashboard. Three buttons are available: <strong>Remove Row</strong>,
                    <strong> Remove Item</strong>, and <strong>Update Item</strong>. These controls
                    help keep the Dashboard clean and correct throughout the pickup process.

                    <strong> Remove Row</strong> is used once the students queued for current
                    loading have been processed. Selecting this option removes the leading row of student IDs from the board.
                    The remaining queue then advances automatically, presenting the next group of
                    students in sequence.

                    <strong> Remove Item</strong> and
                    <strong> Update Item</strong> are provided for correcting mistakes, such as an
                    incorrect ID being entered or a student needing to be adjusted within the
                    queue.
                </p>


                <h3>Admin – Managing Your Organization</h3>
                <p>
                    The <strong>Admin</strong> area provides tools for managing your
                    organization’s settings and users. Administrators can clear the active queue
                    at the end of a pickup cycle, manage subscription plans, and oversee all user
                    accounts. From here, admins can add new staff members by email, deactivate
                    users who no longer need access, and update existing accounts to grant or
                    remove Admin privileges. These controls ensure secure, accurate access for
                    your team.
                </p>


            </div>


        </div >
    );
};

export default About;